import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const LibraryToggle = ({ collapsed, onToggle }) => {
  return (
    <button
      data-testid="library-toggle"
      className="library-toggle"
      onClick={onToggle}
      aria-label={collapsed ? 'Expand loop library' : 'Collapse loop library'}
    >
      {collapsed ? <ChevronRight size={14} /> : <ChevronLeft size={14} />}
    </button>
  );
};

export default LibraryToggle;
